export enum PaymentServiceEnum {
  VAULT = 'vault',
  TRON = 'tron',
}
